import { useCallback } from "react";
import { useDispatch } from 'react-redux'
import { changeDsrModalState, changeDsrPopupState } from "../../digital-sales-room/actions/dsr-actions";

function useLaunchdeckModal() {

  const dispatch = useDispatch();

  const openLaunchdeckModal = useCallback((modalName) => {
    dispatch(changeDsrPopupState(modalName))
    dispatch(changeDsrModalState(true))
  }, []);

  const closeLaunchdeckModal = useCallback(() => {
    dispatch(changeDsrPopupState(""))
    dispatch(changeDsrModalState(false))
  }, []);

  return { openLaunchdeckModal, closeLaunchdeckModal };
}


export default useLaunchdeckModal